import styled from 'styled-components';
import SanitisedEnvironmentLogo from '../../../../../stories/Icons/SanitisedEnvironmentLogo';

export const SafetyAndHygieneContainerWrap = styled.section(
  props => `
    max-width: 120rem;
    width: 100%;
    margin: ${props.theme.spacing.large} auto;
    margin-bottom:0;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    background:${props.theme.colors.goWhite.base};
    `,
);

export const SafetyAndHygieneHeader = styled.div(
  props => `
    border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
    padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
    background: ${props.backgroundColor || props.theme.colors.goGreen.light};
    border-bottom-left-radius:0;
    border-bottom-right-radius:0;
    `,
);

export const SafetyAndHygieneHeaderText = styled.p(
  props => `
    font-size: ${props.theme.font.custom(20)};
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
    color: ${props.color || props.theme.colors.downriver.base};
    `,
);

export const SafetyAndHygieneHotelHeading = styled.p(
  props => `
    font-size: ${props.theme.font.custom(16)};
    font-weight: bold;
    padding: ${props.theme.spacing.custom(16)} ${props.theme.spacing.custom(25)};
    padding-bottom: 0;
    `,
);

export const SafetyAndHygieneHotelSubHeading = styled.p(
  props => `
    font-size: ${props.theme.font.custom(16)};
    padding: ${props.theme.spacing.custom(16)} ${props.theme.spacing.custom(25)}
    `,
);

export const SafetyAndHygieneList = styled.ul(
  props => `
    display:flex;
    list-style-type:disc;
    flex-direction: column;
    padding: ${props.theme.spacing.large} ${props.theme.spacing.xlarge};
    padding-top: 0;
    margin-left:${props.theme.spacing.xlarge}
    >li{
        margin-right:${props.theme.spacing.custom(30)}
        font-size: ${props.theme.font.custom(14)};
    }
    `,
);

export const ViewAllLink = styled.a(
  props => `
  display:inline-flex;
  cursor: pointer;
  font-size:${props.theme.font.base};
  color: ${props.theme.colors.goBrandBlue.base};
  &:hover{
    color: ${props.theme.colors.goBrandBlue.base};
  }
`,
);
